var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social logos / Ig") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing",
    transform: "translate(-617.000000, -10786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(363.000000, 10786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social_icons",
    transform: "translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ig",
    transform: "translate(174.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.37013986 C0,3.76650822 3.76650822,0 8.37013986,0 L23.6287659,0 C28.2323975,0 31.9989057,3.76650822 31.9989057,8.37013986 L32,23.6298601 C31.9989057,28.2334918 28.2323975,32 23.6287659,32 L8.37013986,32 C3.76650822,32 0,28.2334918 0,23.6287659 L0,8.37013986 Z",
    id: "Fill-120-Copy",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(6.565674, 6.565674)",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3470916,3.34958794 C13.7397668,3.34958794 13.2473412,3.84201347 13.2473412,4.4493383 C13.2473412,5.05666313 13.7397668,5.54908867 14.3470916,5.54908867 C14.9544164,5.54908867 15.4479363,5.05666313 15.4479363,4.4493383 C15.4479363,3.84201347 14.9544164,3.34958794 14.3470916,3.34958794",
    id: "Fill-115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45785316,12.3390897 C7.82628321,12.3390897 6.49892282,11.0117293 6.49892282,9.38015935 C6.49892282,7.74749513 7.82628321,6.42013473 9.45785316,6.42013473 C11.0894231,6.42013473 12.4167835,7.74749513 12.4167835,9.38015935 C12.4167835,11.0117293 11.0894231,12.3390897 9.45785316,12.3390897 Z M9.45785316,4.76011353 C6.91037171,4.76011353 4.83780734,6.83158363 4.83780734,9.38015935 C4.83780734,11.9276408 6.91037171,14.0002052 9.45785316,14.0002052 C12.0053346,14.0002052 14.077899,11.9276408 14.077899,9.38015935 C14.077899,6.83158363 12.0053346,4.76011353 9.45785316,4.76011353 L9.45785316,4.76011353 Z",
    id: "Fill-116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63553671,1.76507198 C3.50169271,1.76507198 1.76616626,3.50059843 1.76616626,5.63444243 L1.76616626,13.124782 C1.76616626,15.258626 3.50169271,16.9952467 5.63553671,16.9952467 L13.1258763,16.9952467 C15.2597203,16.9952467 16.996341,15.258626 16.996341,13.124782 L16.996341,5.63444243 C16.996341,3.50059843 15.2597203,1.76507198 13.1258763,1.76507198 L5.63553671,1.76507198 Z M13.1258763,18.7592244 L5.63553671,18.7592244 C2.52887871,18.7592244 0,16.23144 0,13.124782 L0,5.63444243 C0,2.52778443 2.52887871,0 5.63553671,0 L13.1258763,0 C16.2325343,0 18.7603187,2.52778443 18.7603187,5.63444243 L18.7603187,13.124782 C18.7603187,16.23144 16.2325343,18.7592244 13.1258763,18.7592244 L13.1258763,18.7592244 Z",
    id: "Fill-117"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.150f64fda96aaa24b69c13a5df69e897.svg";
export { ForwardRef as ReactComponent };